import { Card, CardBody, Button, Input, Autocomplete, AutocompleteItem, Checkbox } from "@heroui/react"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { MainContainer } from "../../components"
import { apiRoute, ENUM_CERTIFIEDLAB, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, linksUrl, URIEncrypt } from "../../constants/enum"
import { useEffect, useState } from "react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { isMobile } from "react-device-detect"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCancel, faClose, faPenToSquare, faSave, faSearch, faSearchPlus } from "@fortawesome/free-solid-svg-icons"
import { DataGrid } from "@mui/x-data-grid"
import { Box, Drawer } from "@mui/material"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CreateStockParamEntry = () => {
    const [rows, setRows] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selRow, setSelRow] = useState(0)
    const [filFileName, setFilFileName] = useState("")
    const [filLab, setFilLab] = useState("")
    const [filCertiDate, setFilCertiDate] = useState(null)
    const { compCode } = useSelector((state) => state.company)
    const { stockParamUploadDetail } = useSelector((state) => state.stockEntry)
    const { user } = useSelector((state) => state.auth)
    const [allRows, setAllRows] = useState([])
    const [searchText, setSearchText] = useState("")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [isDiableUpdate, setIsDiableUpdate] = useState(false)
    const navi = useNavigate();

    const { isPending: isLoadingData, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "fetchMasterData",

    })
    const { data: paramData = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.getUpdateParamData,
        queryKey: "fetchParamsData",
    })
    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingCurrency",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })

    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
        }
    }, [modSetting])

    useEffect(() => {
        if (stockParamUploadDetail && Object.keys(stockParamUploadDetail).length > 0) {
            const { CFNAME, R_DATE, LABID } = stockParamUploadDetail
            setFilFileName(CFNAME)
            setFilLab(LABID)
            setFilCertiDate(R_DATE)
            funFilterData(CFNAME, LABID, R_DATE)
        }
    }, [stockParamUploadDetail])
    useEffect(() => {
        setRows(paramData)
        setAllRows(paramData)
    }, [paramData])

    const funFilterData = (fName, lab, date) => {

        filterData({
            data: {
                compcode: compCode.join(","),
                filename: fName,
                lab: lab,
                rdate: date == '' || date == "Invalid Date" ? null : date
            }
        })
    }
    const searchInAllKeys = (data, searchText) => {
        if (!searchText) return data;

        const lowerSearch = searchText.toLowerCase();

        return data.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    };

    useEffect(() => {
        const searchData = searchInAllKeys(allRows, searchText)

        setRows(searchData)

    }, [searchText])
    const formField = {
        id: "id",
        fileName: "file_name",
        reportType: "report_type",
        certifiedFrom: "certified_from",
        rDate: "r_date",
        status: "status",
        reportNo: "reportno",
        certiNo: "certino",
        certiDate: "cdate",
        certiType: "certitype",
        lotNo: "lotno",
        pktNo: "pktno",
        sLotNo: "sl_code",
        sPktNo: "spktno",
        shape: "s_code",
        color: "sha_code",
        purity: "q_code",
        carat: "carat",
        stnLnth: "stn_lnth",
        dia: "dia",
        tblDpt: "tbl_dptg",
        tblPtg: "tbl_ptg",
        grdlAvg: "grdl_avg",
        cut: "cut",
        polish: "polish",
        symtry: "symtry",
        flrn: "flrn",
        rapRate: "raprate",
        discPer: "lessper",
        crwnAngl: "crwn_angl",
        crwnHt: "crwn_hght",
        pvlnAngl: "plvn_angl",
        pvlnDpth: "pvln_dpth",
        labId: "labid",
        videoFile: "videofile",
        stkAvailable: "stkavailable",
        fancyCol: "fancy_col",
        fancyColInt: "fancy_col_int",
        fancyColOvrtn: "fancy_col_ovrtn",
        bgm: "bgm",
        milky: "milky",
        eyeClean: "pkt_rem"
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.certiDate)
            acc[key] = new Date()
        else if (key == formField.dia || key == formField.stkAvailable || key == formField.carat || key == formField.rapRate || key == formField.discPer)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})
    const { isError, isPending, mutate: funUpdate } = usePost({
        url: apiRoute.stockEntry.updateParam,
        queryKey: "funUpdateStockParams",
        onSuccessTasks: (data) => {
            funFilterData(filFileName, filLab, filCertiDate)
            setOpenDrawer(false)
            setSelRow(0)
            setFormData({ ...emptyFormField })
            toast.success("Parameter Upated", {
                position: "top-center"
            })
        }
    })

    const [formData, setFormData] = useState({ ...emptyFormField })
    const inputBoxes = {
        Row1: [
            {
                id: formField.status,
                name: formField.status,
                placeholder: "Status",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.reportNo,
                name: formField.reportNo,
                placeholder: "Report No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.milky,
                name: formField.milky,
                placeholder: "Milky",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row2: [
            {
                id: formField.certiNo,
                name: formField.certiNo,
                placeholder: "Certi No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.certiDate,
                name: formField.certiDate,
                placeholder: "Certi. Date.",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.eyeClean,
                name: formField.eyeClean,
                placeholder: "Eye Clean",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row3: [{
            id: formField.certiType,
            name: formField.certiType,
            placeholder: "Certi Type",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: false,
        },
        {
            id: formField.videoFile,
            name: formField.videoFile,
            placeholder: "Video Link",
            type: ENUM_INPUT_TYPE.url,
            size: "sm",
            label: "",
            isrequired: false,
        },
        ],
        Row4: [
            {
                id: formField.lotNo,
                name: formField.lotNo,
                placeholder: "Lot No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.pktNo,
                name: formField.pktNo,
                placeholder: "Pkt No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row5: [
            {
                id: formField.shape,
                name: formField.shape,
                placeholder: "Shape",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.shapeMaster ? masterData?.shapeMaster : [],
                itemkey: "S_Code",
                itemvalue: "S_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: formField.color,
                name: formField.color,
                placeholder: "Color",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.colorMaster ? masterData?.colorMaster : [],
                itemkey: "Sh_Code",
                itemvalue: "Sh_Name",
                readonly: false,
                isrequired: false,
            },
            {
                id: formField.purity,
                name: formField.purity,
                placeholder: "Purity",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.purityMaster ? masterData?.purityMaster : [],
                itemkey: "Q_Code",
                itemvalue: "Q_Name",
                readonly: false,
                isrequired: false,
            },
        ],
        Row6: [
            {
                id: formField.carat,
                name: formField.carat,
                placeholder: "Carat",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.stnLnth,
                name: formField.stnLnth,
                placeholder: "STN LNTH",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.dia,
                name: formField.dia,
                placeholder: "DIA",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row7: [
            {
                id: formField.tblDpt,
                name: formField.tblDpt,
                placeholder: "TBL DPT",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.tblPtg,
                name: formField.tblPtg,
                placeholder: "TBL PTG",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.flrn,
                name: formField.flrn,
                placeholder: "FLRN",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row8: [
            {
                id: formField.cut,
                name: formField.cut,
                placeholder: "Cut",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.polish,
                name: formField.polish,
                placeholder: "Polish",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.symtry,
                name: formField.symtry,
                placeholder: "Symtry.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row12: [
            {
                id: formField.fancyCol,
                name: formField.fancyCol,
                placeholder: "Fancy Color",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.fancyColInt,
                name: formField.fancyColInt,
                placeholder: "Fancy Color Intensity",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.fancyColOvrtn,
                name: formField.fancyColOvrtn,
                placeholder: "Fancy Color Ovrtn",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row9: [
            {
                id: formField.grdlAvg,
                name: formField.grdlAvg,
                placeholder: "GRDL AVG.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.rapRate,
                name: formField.rapRate,
                placeholder: "Rate Price",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.discPer,
                name: formField.discPer,
                placeholder: "Disc %.",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row10: [
            {
                id: formField.crwnAngl,
                name: formField.crwnAngl,
                placeholder: "CRWN ANGL",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.crwnHt,
                name: formField.crwnHt,
                placeholder: "CRWN HT",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.labId,
                name: formField.labId,
                placeholder: "Lab",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row11: [
            {
                id: formField.pvlnAngl,
                name: formField.pvlnAngl,
                placeholder: "PVLN ANGL",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.pvlnDpth,
                name: formField.pvlnDpth,
                placeholder: "PVLN DPTH",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
    }
    const handleChange = (e) => {
        const { value, id, } = e.target
        setFormData({ ...formData, [id]: value })
    }
    const handleAutoCompleteChange = (value, id, name) => {
        setFormData({ ...formData, [name]: value })
    }

    const handleEditRow = (id) => {


        setOpenDrawer(true)
        setSelRow(id)
        const selRow = paramData.filter((ele) => ele.id == id)
        if (selRow && selRow.length > 0) {
            setFormData(selRow[0])
            if (selRow[0].carat > 0) {
                setIsDiableUpdate(false)
            }
            else {
                setIsDiableUpdate(true)
            }
        }
    }

    const itemGridHeadClass = "item-grid-style"
    const columns = [
        {
            field: formField.id,
            headerName: "Action",
            width: 70,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="flex justify-evenly" ><h6> {row.id}</h6>
                    <strong>
                        <FontAwesomeIcon
                            color="green"
                            className={`  cursor-pointer`}
                            onClick={() => handleEditRow(row.id)}
                            icon={faPenToSquare}
                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },
        {
            field: formField.fileName,
            headerName: "File Name",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.fileName]}
                </div>)
        },
        {
            field: formField.rDate,
            headerName: "Date",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.rDate]}
                </div>)
        },
        {
            field: formField.certiDate,
            headerName: "Certi.Date",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.certiDate]}
                </div>)
        },
        {
            field: formField.sLotNo,
            headerName: "Mfg Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.sLotNo]}
                </div>)
        },
        {
            field: formField.sPktNo,
            headerName: "Mfg Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.sPktNo]}
                </div>)
        },
        {
            field: formField.lotNo,
            headerName: "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.lotNo]}
                </div>)
        },
        {
            field: formField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.pktNo]}
                </div>)
        },
        {
            field: formField.shape,
            headerName: "Shape",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.shape]}
                </div>)
        },
        {
            field: formField.color,
            headerName: "Color",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.color]}

                </div>)
        },
        {
            field: formField.purity,
            headerName: "Purity",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.purity]}
                </div>)
        },


        {
            field: formField.carat,
            headerName: "Carat",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.carat]}
                </div>)
        },
        {
            field: formField.labId,
            headerName: "Lab",
            minWidth: 70,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.labId]}
                </div>)
        },
        {
            field: formField.certiNo,
            headerName: "Certi.No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.certiNo]}
                </div>)
        },
        {
            field: formField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.reportNo]}
                </div>)
        },

    ]
    const handlefilter = () => {
        funFilterData(filFileName, filLab, filCertiDate)
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        funUpdate({
            data: {
                comp_code: compCode.join(","),
                r_date: new Date(formData[formField.rDate]),
                certified_from: formData[formField.certifiedFrom],
                report_type: formData[formField.reportType],
                file_name: formData[formField.fileName],
                params_data: [formData],
                login_userid: user.username,
                isexcel_upload: 0,
                mkt_lotno: '0',// isUseMfgNoAsMktno ? '0' : '1',
                is_regmktno: 0,
                location: '',
                rec_status: 3
            }
        })

    }

    const handleClickPrev = () => {
        window.location.href = linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.parameterUpdate;
    }
    const handleReset = () => {
        funFilterData("", "", "")
        setFilCertiDate(null)
        setFilFileName("")
        setFilLab("")
        setRows([])
        setAllRows([])
    }
    const handleChkboxChange = (val, name) => {

        setFormData({ ...formData, [name]: val ? 1 : 0 })
    }


    const exportToExcel = async (jsonData, columns) => {
        if (!jsonData || jsonData.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Data");

        // Only use columns that have actual data (skip action columns)
        const dataColumns = columns.filter((col) => !col.renderCell || col.field !== "id");

        // Add headers
        worksheet.addRow(dataColumns.map((col) => col.headerName));

        // Add rows
        jsonData.forEach((row) => {
            const rowData = dataColumns.map((col) => row[col.field] ?? "");
            worksheet.addRow(rowData);
        });

        // Format header
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.alignment = { vertical: "middle", horizontal: "center" };

        // Optional: set column widths
        worksheet.columns.forEach((col) => (col.width = 20));

        // Generate file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        saveAs(blob, "stockparamupdate.xlsx");
    };


    return (
        <MainContainer
            pageName={"Stock Parameter Update"}
            breadcrumbs={["Stock Entry", "Update Parameter"]}
            prevPage={{
                show: true,
                onClick: handleClickPrev,
            }}
        >

            <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">
                <CardBody>

                    <div className="flex gap-2 justify-start mb-5">
                        <Autocomplete
                            size="sm"
                            className="max-w-23"
                            classNames={{
                                label: " font-semibold text-sm",
                            }}
                            defaultItems={masterData && masterData?.fileMaster ? masterData.fileMaster : []}
                            placeholder=""
                            label="File Name"
                            selectedKey={filFileName}
                            //selectionMode="single"
                            onSelectionChange={setFilFileName}
                            variant="flat"
                            isVirtualized
                            menuTrigger={"input"}
                            color="warning"
                        >
                            {(list) => (
                                <AutocompleteItem
                                    key={list.FName}
                                >
                                    {list.FName}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                        <Autocomplete
                            size="sm"
                            label={"CertiFied From"}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            //labelPlacement={"outside"}
                            placeholder={""}
                            menuTrigger={"input"}
                            color="success"
                            className="max-w-23 font-semibold"
                            classNames={{
                                label: "font-semibold",
                            }}
                            isClearable={true}
                            isVirtualized
                            defaultItems={ENUM_CERTIFIEDLAB} //{masterData && masterData?.labMaster ? masterData.labMaster : []}
                            onSelectionChange={setFilLab}
                            selectedKey={filLab}
                        >
                            {(list) => (
                                <AutocompleteItem

                                    key={list.key}
                                >
                                    {list.value}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"Date"}
                                views={["day", "month", "year"]}
                                format="DD/MM/YYYY"
                                value={
                                    filCertiDate
                                        ? dayjs(filCertiDate)
                                        : filCertiDate
                                }
                                onChange={(newValue) => {
                                    setFilCertiDate(
                                        newValue != '' && newValue != 'Invalid Date' ?
                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                    );
                                }}
                                //isRequired={item.required}
                                className="w-full "
                                slotProps={{
                                    textField: { size: "small", required: true },
                                }}
                            />
                        </LocalizationProvider>
                        <Button
                            color="success"
                            variant="shadow"
                            size="sm"
                            onPress={handlefilter}
                            startContent={<FontAwesomeIcon icon={faSearch} />}
                        >
                            Find
                        </Button>
                        <Button
                            color="warning"
                            variant="shadow"
                            size="sm"
                            onPress={handleReset}
                            startContent={<FontAwesomeIcon icon={faSearch} />}
                        >
                            Reset
                        </Button>
                    </div>
                    {/* {rows && rows?.lengt
                    h > 0 ? (
                        <> */
                    }
                    <div className=" text-right">
                        <button className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700" onClick={() => exportToExcel(rows, columns)}>
                            Export to Excel
                        </button>
                    </div>

                    <div className="my-2">
                        <Input type="text" size="sm"
                            radius="none" placeholder="Search ...."
                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                            variant="bordered" className="bg-white border-1 border-gray-300"
                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                    </div>
                    <Box sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            editMode="row"
                            columnHeaderHeight={30}
                            rowHeight={30}
                            onRowClick={(params) => {
                                setSelRow(params.id);
                            }}
                            //disableColumnSorting={true}
                            //disableColumnMenu={true}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            getRowClassName={(params) => {
                                //console.log(params.id,selRow)
                                if (params.id == selRow)
                                    return 'select-row'
                                else
                                    return 'row-class';
                            }}

                            // getRowClassName={getRowClassName}
                            sx={{
                                '& .MuiDataGrid-columnHeaders': {
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                },
                                '& .select-row': {
                                    //  backgroundColor: "#000000",
                                    fontSize: "11px"
                                },
                                '& .row-class': {
                                    fontSize: "11px"
                                },

                            }}
                            columnVisibilityModel={{
                                [formField.sLotNo]: isUseMfgNoAsMktno ? false : true,
                                [formField.sPktNo]: isUseMfgNoAsMktno ? false : true,
                            }}
                        />

                    </Box>

                    {/* </>
                    ) : (
                        <h4>No Data Found</h4> 
                   // )}*/}
                    <Drawer open={openDrawer} anchor="top">
                        <div className=" text-orange-700 bg-orange-50 text-center border-1 font-semibold flex justify-between" >Update Parameter
                            <FontAwesomeIcon className="cursor-pointer p-2 bg-gray-700 text-white" onClick={() => setOpenDrawer(false)} icon={faClose}></FontAwesomeIcon>

                        </div>
                        <form onSubmit={handleSubmit} autoComplete='off'>
                            <div className="text-center   flex gap-2 justify-center  mb-1">
                                <Checkbox size="md"
                                    classNames={{ "label": "text-pink-700 text-sm font-semibold" }}
                                    className="py-1 px-2 mt-2 border-0 border-pink-200 " color={"danger"} isSelected={formData[formField.stkAvailable]} onValueChange={(e) => handleChkboxChange(e, formField.stkAvailable)} >Stock Availability</Checkbox>
                                <Checkbox size="md"
                                    classNames={{ "label": "text-pink-700 text-sm font-semibold" }}
                                    className="py-1 px-2 mt-2 border-0 border-pink-200 " color={"success"} isSelected={formData[formField.bgm]} onValueChange={(e) => handleChkboxChange(e, formField.bgm)} >BGM</Checkbox>

                            </div>
                            {

                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            isLoading={isLoadingData}
                                                            menuTrigger={"input"}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, '', item.name)
                                                            }
                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        setFormData((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                            };
                                                                        });
                                                                    }}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            readOnly={item.name == [formField.lotNo] || item.name == [formField.pktNo] ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            <div className="justify-center flex gap-5 mt-5">
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    isLoading={isPending}
                                    isDisabled={selRow && selRow > 0 && !isDiableUpdate ? false : true}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Update
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    onPress={() => setOpenDrawer(false)}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    close
                                </Button>
                            </div>
                        </form >
                    </Drawer>
                </CardBody>

            </Card >
        </MainContainer >
    )
}
export default CreateStockParamEntry